import React, { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa6";
import { Link, useLocation } from "react-router-dom";
import { CiLinkedin } from "react-icons/ci";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => setIsOpen(false);
  const location = useLocation();

  const links = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Services", path: "/service" },
    { name: "Projects", path: "/projects" },
    { name: "Clients", path: "/clients" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <nav className="sticky top-0 left-0 w-full z-50 bg-black/90 backdrop-blur-md border-b border-white/10">
      <div className="max-w-screen-xl mx-auto flex items-center justify-between px-6 py-3">
        {/* Left side: Logo or Menu Button (for mobile) */}
        <div className="flex items-center space-x-4">
          {/* Toggle Button (Mobile only) */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white border border-white/30 p-2 rounded-md hover:bg-white hover:text-black transition-all duration-300"
          >
            {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>

          {/* Desktop Menu */}
          <ul className="hidden md:flex space-x-8 text-white font-medium">
            {links.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <li key={link.path} className="relative group">
                  <Link
                    to={link.path}
                    className={`transition duration-300 ${
                      isActive ? "text-white" : "hover:text-gray-200"
                    }`}
                  >
                    {link.name}
                  </Link>
                  <span
                    className={`absolute left-0 bottom-0 h-[2px] rounded-full bg-gradient-to-r from-gray-300 to-white transition-all duration-300 ${
                      isActive ? "w-full" : "w-0 group-hover:w-full"
                    }`}
                  ></span>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Social Icons */}
        <div className="flex items-center space-x-4 text-white">
          <Link
            to="https://www.linkedin.com/company/redecorgroup/?viewAsMember=true"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-300 transition"
          >
            <CiLinkedin size={28} />
          </Link>
          <Link
            to="https://www.facebook.com/profile.php?id=61563487254805"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-300  transition"
          >
            <FaFacebookF size={24} />
          </Link>
          <Link
            to="https://www.instagram.com/redecor.egy?igsh=MXcwZDRid3VmeXViaA=="
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-300  transition"
          >
            <FaInstagram size={24} />
          </Link>
          <Link
            to="https://www.tiktok.com/@redecor.egy?is_from_webapp=1&sender_device=pc"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-300 transition"
          >
            <FaTiktok size={24} />
          </Link>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-[64px] left-0 w-full bg-black/95 backdrop-blur-md shadow-lg transition-all duration-300 ease-in-out ${
          isOpen
            ? "opacity-100 translate-y-0"
            : "opacity-0 -translate-y-5 pointer-events-none"
        }`}
      >
        <ul className="flex flex-col items-center space-y-4 py-6 text-white font-medium">
          {links.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <li key={link.path} className="relative group">
                <Link
                  to={link.path}
                  onClick={handleClose}
                  className={`transition duration-300 ${
                    isActive ? "text-white" : "hover:text-gray-300"
                  }`}
                >
                  {link.name}
                </Link>
                <span
                  className={`absolute left-0 bottom-0 h-[2px] rounded-full bg-gradient-to-r from-gray-300 to-white transition-all duration-300 ${
                    isActive ? "w-full" : "w-0 group-hover:w-full"
                  }`}
                ></span>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
